<template>
    <div id="wp-contact-list-page">
        <h3 class="title">{{ $t("wp.contactList") }}</h3>
        <div v-if="selections.length" class="selection-bar">
            <section class="uncheck" @click="unselectAll">
                <span class="material-icons"> arrow_back </span>
                {{ $t("chatbotv2.uncheckAll") }}
            </section>
            <section class="select" @click="selectAll">{{ $t("chatbotv2.selectAll") }}</section>
            <section class="queries">+{{ selections.length }}{{ $t("wp.contactSelected") }}</section>
            <section class="actions">
                <a-button class="d-none" ghost disabled>{{ $t("wp.sendBroadcastMessage") }}</a-button>
            </section>
        </div>
        <div class="my-1 wp-list-searching-input">
            <a-input-search
                v-model="searchText"
                :placeholder="$t('message.search')"
                class="row search-input"
                @input="onSearch($event.target.value)"
            />
            <div class="mr-5">
                <a-button @click="showModal">
                    {{ $t("wp.startChatWithAnyNo") }}
                </a-button>
                <a-modal
                    :confirm-loading="confirmLoading"
                    :title="$t('wp.typeInANumberDesc')"
                    :visible="visible"
                    class="row d-flex flex-row"
                    @cancel="handleCancel"
                    @ok="handleOk(wpContactNumber)"
                >
                    <div v-if="showAlertMessage" class="pb-3">
                        <a-alert :message="$t('wp.toLittleChar')" type="error" banner />
                    </div>
                    <div class="d-flex flex-row align-items-center justify-content-center">
                        <vue-country-code
                            :defaultCountry="userLastCountry"
                            :enabledCountryCode="true"
                            class="col-3 country-code"
                            @onSelect="onSelect($event)"
                        />
                        <div class="col-8">
                            <a-input
                                v-model="wpContactNumber"
                                v-mask="'##########'"
                                :placeholder="$t('message.phone')"
                                autocomplete="off"
                                trim
                                type="text"
                            />
                        </div>
                    </div>
                </a-modal>
            </div>
        </div>
        <div>
            <a-table
                :key="'vtable-' + renderCount"
                :columns="cols"
                :dataSource="allContacts"
                :loading="loading"
                :locale="{
                    emptyText: $t('message.noContactFound'),
                }"
                :pagination="pagination"
                :row-selection="{ onChange: rowSelectionOnChange, selectedRowKeys: selections }"
                class="custom-table"
                rowKey="id"
                size="small"
                @change="handleTableChange"
            >
                <div></div>
                <div slot="avatarSlot" slot-scope="data, item" class="p-1">
                    <a-avatar
                        :size="30"
                        :src="$_.get(item, 'profilePicThumbObj.eurl')"
                        :username="item.name"
                        shape="square"
                        style="background-color: #3899ff; border-radius: 7px !important"
                    >
                        {{ !!item.name ? item.name.substr(0, 1).toLocaleUpperCase() : "" }}
                    </a-avatar>
                </div>
                <div slot="phoneNumber" slot-scope="data, item" class="p-1">
                    {{ item.phoneNumber.slice(0, -5) }}
                </div>
                <div slot="action" slot-scope="data, item">
                    <div class="d-flex justify-content-end" style="margin-right: -10px !important">
                        <md-button
                            id="joinChat"
                            v-tippy="{
                                followCursor: true,
                                placement: 'bottom-end',
                                theme: isDarkMode ? 'light-border' : 'google',
                            }"
                            :content="$t('wp.startChatWp')"
                            data-v-step="16"
                            @click="startChat(item.phoneNumber)"
                        >
                            {{ $t("wp.startChatWp") }}
                            <md-icon style="color: #06e576; font-size: 12px"> whatsapp</md-icon>
                        </md-button>
                        <button
                            class="delete-chat"
                            id="deleteChat"
                            content="Kişiyi Sil"
                            data-v-step="16"
                            @click="deleteVisitorConfirm(item)"
                        >
                            <span class="material-icons">close</span>
                        </button>
                    </div>
                </div>
            </a-table>
        </div>
    </div>
</template>
<script>
import SYSTEM_PUBSUB from "../../../utils/systemPubSub";
import { sendSocketMessage, socketMessageStream } from "../../../utils/socketStream";
import { filter, first, timeout } from "rxjs/operators";
import _ from "lodash";
import Fuse from "fuse.js";
import { tableSorter } from "../../../utils/utils";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import Vue from "vue";
import VueTheMask from "vue-the-mask";
import VueCountryCode from "vue-country-code";
import log2 from "../../../utils/log2";
import ChatWatcher from "../../../ChatWatcherV2";

Vue.use(VueTheMask);
Vue.use(VueCountryCode);
const log = log2("ContactListV2");
export default {
    name: "ContactListV2",
    components: { VueCountryCode },

    props: {
        channel: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            visible: false,
            confirmLoading: false,
            showAlertMessage: false,
            internationalCallingCode: "90",
            wpContactNumber: "",
            createCustomerGroupFormVisible: false,
            lastPersonelContacts: [],
            searchText: "",
            renderCount: 0,
            currentSort: {
                columnKey: "connectionTime",
                order: "ascend",
            },
            pagination: {
                total: 0,
                current: 1,
                defaultPageSize: 10,
                hideOnSinglePage: false,
                pageSizeOptions: ["10", "15", "20", "50", "100"],
                showQuickJumper: true,
                showSizeChanger: true,
            },
            cols: [
                {
                    key: "profilePicThumbObj",
                    dataIndex: "profilePicThumbObj.eurl",
                    title: this.$t("message.profile"),
                    ...tableSorter("profilePicThumbObj", "string", this.currentSort),
                    scopedSlots: { customRender: "avatarSlot" },
                },
                {
                    key: "name",
                    dataIndex: "name",
                    title: this.$t("message.name"),
                    ...tableSorter("name", "string", this.currentSort),
                    scopedSlots: { customRender: "name" },
                },
                {
                    key: "phoneNumber",
                    dataIndex: `phoneNumber`,
                    title: this.$t("message.number"),
                    ...tableSorter("phoneNumber", "string", this.currentSort),
                    scopedSlots: { customRender: "phoneNumber" },
                },
                {
                    key: "channelName",
                    dataIndex: `channelName`,
                    title: "Kanal adı",
                    ...tableSorter("channelName", "string", this.currentSort),
                    scopedSlots: { customRender: "channelName" },
                },
                {
                    title: "Action",
                    key: "operation",
                    scopedSlots: { customRender: "action" },
                    width: "100px",
                },
            ],
            loading: true,
            selections: [],
            allContacts: [],
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            siteId: (state) => state.site.site._id,
            user: (state) => state.auth.user,
            userLastCountry: (state) => _.get(state.auth.user, "lastGeoLocation.country"),
            channelContacts: (state) => state.whatsapp.channelContacts,
            channelInfo: (state) => state.whatsapp.channelInfo,
        }),

        ...mapGetters({
            isDarkMode: "user/isDarkMode",
            myActiveConversations: "chat/getMyActiveConversations",
        }),
    },
    methods: {
        ...mapActions({
            getSettings: "setting/getSettings",
            getContactListByChannel: "chat/getContactListByChannel",
            deleteVisitor: "visitor/deleteVisitor",
        }),
        ...mapMutations({
            changePurchaseStatus: "whatsapp/changePurchaseStatus",
            setSearchingResultWPContact: "whatsapp/setSearchingResultWPContact",
        }),
        getSearchingResultsOfWpContact() {
            return _.get(this.channelContacts, [this.channel._id, "searchingResultsOfWpContact"], []) || [];
        },
        selectAll() {
            this.selections = this.allContacts.map((x) => x.phoneNumber);
            this.renderCount++;
        },
        unselectAll() {
            this.selections = [];
            this.renderCount++;
        },
        rowSelectionOnChange(selectedRowKeys, selectedRows) {
            this.selections = selectedRowKeys;
            log("rowSelectionOnChange", { selections: this.selections });
            this.renderCount++;
        },
        deleteVisitorConfirm(item) {
            this.$confirm({
                title: "Kişiyi sil",
                content: "Kişiyi slimek istediğinizden emin misiniz?",
                okText: "Sil",
                okType: "danger",
                cancelText: "Kapat",
                onOk: () => {
                    this.$message.loading("Konuşma silindi", 0);
                    this.deleteVisitor(item._id).then((res) => {
                        this.$message.destroy();
                        this.$message.success("Konuşma silindi");
                    });
                    this.allContacts = this.allContacts.filter((x) => x._id !== item._id);
                },
            });
        },
        startChat(whatsappNumber) {
            if (this.channelInfo[this.channel._id].status.status.STATE !== "CONNECTED") {
                this.$message.error("Whatsapp bağlantısı yok");
                return;
            }
            whatsappNumber = whatsappNumber || "";
            whatsappNumber = whatsappNumber.includes("@c.us") ? whatsappNumber : whatsappNumber + "@c.us";
            ChatWatcher.startChatImmediately({
                whatsappNumber: whatsappNumber,
                channelId: this.channel._id,
                channelType: "whatsapp-qr",
            });
        },
        refresh: _.debounce(function () {
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
            }, 500);
            this.pagination.current = 1;
            this.sendGetContactMessage();
        }, 400),
        onShowSizeChange(current, pageSize) {},
        async handleTableChange(pagination, filters, sorter) {
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
            }, 370);
            this.pagination.current = pagination.current;
            this.pagination.pageSize = pagination.pageSize;
            await this.sendGetContactMessage();
        },
        getFilteredRows(getContacts = this.allContacts) {
            let fuzzySearch = new Fuse(getContacts, { keys: ["name", "phoneNumber"] });
            return this.searchText.length > 0 ? fuzzySearch.search(this.searchText).map((x) => x.item) : getContacts;
        },
        onSearch(value) {
            this.searchText = value;
            this.refresh();
        },
        onSelect(value) {
            log("onSelect", value);
            this.internationalCallingCode = value.dialCode;
        },
        showModal() {
            this.visible = true;
        },
        handleOk(number) {
            this.wpContactNumber = number.replace(/[{()}]/g, "");
            const contactNumber = this.internationalCallingCode + this.wpContactNumber;
            if (contactNumber.length < 6) {
                this.showAlertMessage = true;
                return;
            }
            this.confirmLoading = true;
            this.showAlertMessage = false;
            this.visible = false;
            this.confirmLoading = false;

            const searchingResultsOfWpContact = this.getSearchingResultsOfWpContact();
            const searchedContacts = JSON.parse(JSON.stringify(searchingResultsOfWpContact));
            const isNumberExistInSearchHistory = searchedContacts[number];
            if (isNumberExistInSearchHistory !== undefined) {
                this.readyToChatStartingControl(isNumberExistInSearchHistory);
            } else {
                socketMessageStream
                    .pipe(
                        filter((x) => x.cmd === "whatsapp_contacts_is_includes_number"),
                        timeout(5000),
                        first()
                    )
                    .toPromise()
                    .then((x) => {
                        let searchingResultWPContact = {};
                        const isExist = _.get(x, "data.contactIsExist") || false;
                        searchingResultWPContact[`${number}`] = isExist;
                        this.readyToChatStartingControl(isExist);
                        this.setSearchingResultWPContact(searchingResultWPContact, this.channel._id);
                    })
                    .catch((err) => {
                        this.$message.error(this.$t("wp.chatNotStarted"));
                    });

                sendSocketMessage("whatsapp number-is-exist-in-contacts", {
                    siteId: this.site._id,
                    searchingPhoneNumber: contactNumber,
                    channelId: this.channel._id,
                });
            }
        },
        readyToChatStartingControl(isExist) {
            this.startChat(this.internationalCallingCode + this.wpContactNumber);
        },
        handleCancel(e) {
            this.visible = false;
            this.showAlertMessage = false;
        },
        async sendGetContactMessage() {
            const allContacts = await this.getContactListByChannel({
                channel: this.channel._id,
                pageCount: this.pagination.current,
                perPage: this.pagination.pageSize || this.pagination.defaultPageSize || 10,
                searchValue: this.searchText,
            });
            this.allContacts = aallContacts.result.map((x) => {
                x.channelName = !!x.channel ? x.channel.name : "-";
                x.name = !!x.fullname ? x.fullname : "-";
                x.phoneNumber = !!x.whatsappNumber ? x.whatsappNumber : "-";
                return x;
            });
            this.pagination.total = allContacts.totalResult;
            this.loading = false;
        },
    },

    async mounted() {
        await this.sendGetContactMessage();
    },
    watch: {
        channelContacts: {
            handler: function (newValue) {
                const total = _.get(newValue, [this.channel._id, "total"], 0) || 0;
                if (this.pagination.total !== total) {
                    this.pagination.total = total;
                }
            },
            deep: true,
        },
    },
};
</script>

<style scoped lang="scss">
#wp-contact-list-page {
    margin: 30px;

    .delete-chat {
        background: none;
        border: none;
        margin-right: 5px;

        &:hover {
            background-color: #c0bfbf;
            border-radius: 10px;
        }
    }

    .ant-modal-body {
        padding: 24px;
        font-size: 14px;
        line-height: 1.5;
        word-wrap: break-word;
        display: flex !important;
        flex-direction: row !important;
        height: 80px !important;
    }

    .ant-table-row {
        border-bottom: 1px solid lightgrey;
    }

    .ant-table table {
        border-collapse: collapse !important;
    }

    .ant-table-small {
        border: none !important;
    }

    .ant-table-body > table > .ant-table-tbody > tr > td {
        border: none !important;
    }

    .ant-table-body > table {
        border-right: none !important;
        border-left: none !important;
        line-height: 10px !important;
    }

    .ant-table-body > table > .ant-table-thead > tr > th {
        border: none !important;
    }

    .ant-table-small {
        .ant-table-tbody {
            td {
                padding: 2px 2px !important;
                height: 10px !important;
            }

            .ant-table-row {
                height: 10px !important;
            }
        }
    }

    .selection-bar {
        align-items: center;
        background: #006cff;
        color: #fff;
        display: flex;
        flex-wrap: wrap;
        height: 50px;
        left: 0;
        padding: 10px 30px;
        position: static;
        right: 0;

        section.uncheck {
            align-items: center;
            cursor: pointer;
            display: flex;
            grid-area: uncheck;
            transition: all 0.3s;

            &:hover {
                opacity: 0.8 !important;
            }

            .material-icons {
                font-size: 15px;
                margin-right: 10px;
                margin-top: 2px;
            }
        }

        section.select {
            cursor: pointer;
            grid-area: select;
            margin-left: 20px;
            transition: all 0.3s;

            &:hover {
                opacity: 0.8 !important;
            }
        }

        section.queries {
            grid-area: queries;
            margin-left: auto;
        }

        section.actions {
            align-items: center;
            display: flex;
            grid-area: actions;
            justify-content: center;
            margin-left: 20px;
            gap: 5px;

            div {
                align-items: center;
                border: 1px solid #fff;
                border-radius: 100%;
                cursor: pointer;
                display: flex;
                height: 26px;
                justify-content: center;
                margin: 0 5px;
                transition: opacity 0.3s;
                width: 26px;

                .material-icons {
                    color: #fff;
                    font-size: 15px;
                }
            }
        }
    }

    .wp-list-searching-input {
        margin: 5px 5px !important;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        text-align: center;
    }

    .inputs {
        border: 1px solid #e5e5e5;
        position: relative;
        border-radius: 6px;
        -webkit-box-shadow: 0 0 1px #00000080;
        box-shadow: 0 0 1px #00000080;
    }
}
</style>
